import React, { FC } from "react";
import { Id } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { activeSubscriptionIdState, people_teamsState } from "../../../atoms";
import { Button, useToast } from "@chakra-ui/react";
import { unlinkPersonFromTeam } from "../../../api/unlink-person-from-team";

type Props = {
  personId: Id;
  teamId: Id;
  onSuccess: () => void;
};

export const UnlinkPersonFromTeam: FC<Props> = (props) => {
  const { personId, teamId, onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const setPeople_teams = useSetRecoilState(people_teamsState);

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        unlinkPersonFromTeam({
          personId,
          teamId,
          subscriptionId: activeSubscriptionId as Id,
        }),
    },

    actions: {
      success: (_, event: any) => {
        setPeople_teams(event.data.people_teams);
        onSuccess();
        toast({
          title: "koppeling tussen persoon en team verwijderd",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "verwijderen van koppeling niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <Button
      type="submit"
      size="sm"
      isLoading={state.matches("loading")}
      onClick={() => {
        send(state.matches("failure") ? "RETRY" : "FETCH");
      }}
    >
      bevestig
    </Button>
  );
};
